export default __webpack_public_path__ + "static/16-vaporwave-456e465676a1fe1a41bc81171e84c057.png";